import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["schedule"];

  connect() {
    this.toggle();
  }

  toggle(e) {
    if (e) e.preventDefault();
    this.scheduleTarget.classList.toggle("d-none");
  }
}
